import SelectLabelFormatter from '../SelectLabelFormatter'

import DestinationWFFMDataExchange from '@/services/DestinationWFFMDataExchange'

/**
 * A mixin adding destination editing logic and data
 */
export default {
  mixins: [
    SelectLabelFormatter,
  ],
  data () {
    return {
      dx: { destination: new DestinationWFFMDataExchange(this.form) },
      popups: { destination: false },
      destinations: [],
      allDestinationsSelected: false,
    }
  },
  created () {
    this.destinations = this.dx.destination.data
  },
  computed: {
    destinationsEnabled () {
      return this.destinations.filter(destination => destination.enabled)
    },
    anyDestinationEnabled () {
      return this.destinations.some(destination => destination.enabled)
    },
    selectedDestinations () {
      return this.destinations.filter(destination => destination.selected)
    },
    selectedDestinationLabel () {
      return this.getFormattedSelectLabel(this.selectedDestinations, 'Kierunek podróży')
    },
    selectedDestinationValue () {
      return this.getFormattedSelectValue(this.selectedDestinations, 'Dowolny kierunek')
    },
  },
  methods: {
    allDestinationsToggleSelected (selected) {
      this.allDestinationsSelected = selected
      this.updateAndReselectList('airports')
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/search/logic/Destination.js